import { AppState, FeedPageOrlandoAppState } from '../../../initialStateRegistration';
import { SECTION_NAMES } from '../../../../templates/templates.const';
import { FeedPageOrlandoMinorSections, FeedPageSectionNames, FeedPageOrlandoTopSection } from './feedPageOrlando.initialState';

export const getFeedPage = (state: AppState) => (state as FeedPageOrlandoAppState).template;

export const getSectionDataByKey = (key: FeedPageSectionNames) => (state: AppState) => getFeedPage(state)[key];

export const getSectionArticlesByKey = (key: FeedPageOrlandoMinorSections) => (state: AppState) => getFeedPage(state)[key].articles;

export const getSectionTitleByKey = (key: FeedPageSectionNames) => (state: AppState) => getFeedPage(state)[key].sectionTitle;

export const getShowMorePaginationTextByKey = (key: FeedPageOrlandoMinorSections) => (state: AppState) => getFeedPage(state)[key].showMorePaginationText;

export const getShowMorePaginationURLByKey = (key: FeedPageOrlandoMinorSections) => (state: AppState) => getFeedPage(state)[key].showMorePaginationURL;

export const getSectionSubtitle = (key: FeedPageOrlandoTopSection) => (state: AppState) => getFeedPage(state)[key].sectionSubtitle;

export const getSectionImage = (key: FeedPageOrlandoTopSection) => (state: AppState) => getFeedPage(state)[key].image;

const getSponsoredSection = (state: AppState) => getFeedPage(state)[SECTION_NAMES.SPONSOR_SECTION];

export const getSponsoredText = (state: AppState) => getSponsoredSection(state).sponsoredText;

export const getLogo = (state: AppState) => getSponsoredSection(state).logo;

export const getMetadataDescription = (state: AppState) => getFeedPage(state).metadataDescription;

export const getMetadataTitle = (state: AppState) => getFeedPage(state).metadataTitle;

export const getMetadataAdsCategory = (state: AppState) => getFeedPage(state).metadataAdsCategory;

export const getMetadataImage = (state: AppState) => getFeedPage(state).metadataImage;
